import React from 'react';

/**
 * Article 피드 공용 레이아웃.
 * 공개 피드와 어드민 피드가 같은 그리드를 써야 해서 한 곳에 모아둔다.
 *
 * 그리드 브레이크포인트
 * - ~736px   : 1열
 * - 737~1023 : 2열
 * - 1024px~  : 3열
 *
 * 프로젝트의 named 브레이크포인트(tabletH 768 / tabletV 1180)와 기준점이 달라
 * 임의값 variant(min-[737px], min-[1024px])를 쓴다.
 */
export const GRID_CLASS =
  'grid grid-cols-1 gap-6 min-[737px]:grid-cols-2 min-[1024px]:grid-cols-3 min-[1024px]:gap-10';

/** 화면을 꽉 채우고 여백만 단계적으로 넓힌다 (16 → 40 → 80) */
export const CONTAINER_CLASS =
  'w-full px-4 pb-10 pt-6 min-[737px]:px-10 min-[737px]:pb-14 min-[737px]:pt-8 min-[1024px]:px-20 min-[1024px]:pb-20 min-[1024px]:pt-10';

export const ArticleSkeleton = () => (
  <div className='flex w-full animate-pulse flex-col overflow-hidden rounded-[30px] bg-grayscale-gray00 ring-[1px] ring-grayscale-gray02'>
    <div className='h-[240px] w-full bg-grayscale-gray01' />
    <div className='flex flex-col gap-2 p-4'>
      <div className='h-5 w-4/5 rounded bg-grayscale-gray01' />
      <div className='h-4 w-full rounded bg-grayscale-gray01' />
      <div className='h-[26px] w-32 rounded-full bg-grayscale-gray01' />
    </div>
  </div>
);

export const SkeletonGrid = ({ count = 6 }) => (
  <div className={GRID_CLASS}>
    {Array.from({ length: count }).map((_, index) => (
      <ArticleSkeleton key={index} />
    ))}
  </div>
);

export const StateMessage = ({ title, description }) => (
  <div className='flex flex-col items-center gap-2 py-20 text-center'>
    <p className='typo-b16Strong text-text-primary'>{title}</p>
    {description && (
      <p className='typo-b13 text-text-placeholder'>{description}</p>
    )}
  </div>
);
